import { cloneElement, ReactElement } from 'react';
import cn from 'classnames';
import { IIconProps } from '../../Icon/Icon';
require("./TabBar-ButtonIcon.css");
var styles = {
  "Root": "TabBar-ButtonIcon-module-Root_18e",
  "ButtonIconActive": "TabBar-ButtonIcon-module-ButtonIconActive_2lJ"
};
export const TabBarButtonIcon = ({
  defaultIcon,
  isActive,
  ...props
}) => {
  return /*#__PURE__*/cloneElement(defaultIcon, {
    ...props,
    className: cn(styles.Root, {
      [styles.ButtonIconActive]: isActive
    })
  });
};